export default {
  // 广告分析接口
  goodsAnalyse: {
    url: '/operationads/analyse',
    method: 'post',
    desc: '广告分析-商品层级初始数据'
  },
  locationDate: {
    url: '/operationads/analyse/locationDate',
    method: 'post',
    desc: '广告分析-广告位初始数据'
  },
  keywordAnalyse: {
    url: '/operationads/keyword/analyse',
    method: 'post',
    desc: '关键词分析初始数据'
  },
  keywordAsin: {
    url: '/operationads/keyword/analyse/asin',
    method: 'post',
    desc: '关键词分析-关联商品'
  },
  keywordSearch: {
    url: '/operationads/keyword/analyse/search',
    method: 'post',
    desc: '关键词分析-关联搜索词'
  },
  keywordAnalyseDetails: {
    url: '/operationads/keyword/analyse/details',
    method: 'post',
    desc: '关键词分析初始数据'
  },
  analysedDetails: {
    url: '/operationads/analyse/details',
    method: 'post',
    desc: '广告分析-关键词层级子节点数据'
  },
  campaignList: {
    url: '/operationads/analyse/campaignList',
    method: 'post',
    desc: '广告活动列表数据'
  },
  adGroupList: {
    url: '/operationads/analyse/adGroupList',
    method: 'post',
    desc: '广告组列表数据'
  },
  getKeywords: {
    url: '/operationads/analyse/keywords',
    method: 'post',
    desc: '关联关键词数据'
  },
  adsTypeData: {
    url: '/operationads/analyse/adsTypeData',
    method: 'post',
    desc: '广告类型数据'
  },
  targetData: {
    url: '/operationads/analyse/targetData',
    method: 'post',
    desc: '商品投放数据'
  },
  getAsins: {
    url: '/operationads/analyse/asin',
    method: 'post',
    desc: '数据详情数据'
  },
  searchData: {
    url: '/operationads/analyse/searchData',
    method: 'post',
    desc: '数据详情数据'
  },
}
